import React from "react";

import { useModalContext } from "./Modal";

export default function ModalHeader({
  children,
  styles,
  containerStyles,
}: {
  children: React.ReactNode;
  styles?: React.CSSProperties;
  containerStyles?: React.CSSProperties;
}) {
  const { onClose } = useModalContext();

  const defaultStyle = { padding: "48px 48px 0px 48px", alignItems: "flex-start" };

  return (
    <header style={{ ...defaultStyle, ...styles }} className="modal-card-head">
      <div style={{ ...containerStyles }}>{children}</div>
      <button
        style={{ position: "absolute", top: "20px", right: "20px" }}
        className="delete"
        data-testid="modal-header-close-button"
        aria-label="close"
        onClick={onClose}
      ></button>
    </header>
  );
}
